module.exports = __webpack_public_path__ + "img/34.948ff150.png";